(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const CN_ADDED = '!added';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    const ATTR_SUCCESS_INDICATOR = 'data-to-cart-success';
    const SUCCESS_TEXT = '✓ Added to basket';
    const SUCCESS_DURATION = 1800;
    // Was 1500ms. That was an artificial pause between the cart actually
    // updating and the button showing it, stacked on top of the real
    // network round trip - on mobile especially it read as broken/laggy
    // rather than quick. Kept short rather than removed outright so the
    // loading spinner still gets a beat to be seen instead of just
    // flashing away, but it no longer makes every add feel delayed.
    const UPDATE_DELAY = 150;

    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }

        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartErrorHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._insertSuccessIndicator();
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick() {
            // Tapping again while the last "Added to basket" confirmation
            // is still showing (easy to do on mobile) used to leave that
            // confirmation's own revert timer running underneath this new
            // click, so it could clear mid-way through the new cycle and
            // the two states would visibly clash. Clearing any pending
            // timers and resetting first makes every click start from the
            // same clean state.
            clearTimeout(this._updateTimeout);
            clearTimeout(this._addedTimeout);
            this.added = false;
            this.pending = true;
            this.loading = true;
            !this.belongsToForm && this.addToCart(this.cartItem);
        }

        addToCart(items) {
            this.publish('cart:add', {
                items
            });
        }

        // Only the button that was actually clicked (this.pending) reacts —
        // cart:update/cart:error are global events, so every product-to-cart
        // instance on the page (e.g. the main buy button and a promo box's
        // gift button) would otherwise all flash together.
        _cartUpdateHandler() {
            if (!this.pending) return;
            this.pending = false;
            this._updateTimeout = setTimeout(() => {
                this.loading = false;
                this.added = true;
                this._addedTimeout = setTimeout(() => {
                    this.added = false;
                }, SUCCESS_DURATION);
            }, UPDATE_DELAY)
        }

        _cartErrorHandler() {
            if (!this.pending) return;
            this.pending = false;
            clearTimeout(this._updateTimeout);
            this.loading = false;
        }

        _insertSuccessIndicator() {
            if (!this.$button || this.$button.querySelector(`[${ATTR_SUCCESS_INDICATOR}]`)) return;
            const el = document.createElement('span');
            el.setAttribute(ATTR_SUCCESS_INDICATOR, '');
            el.className = '#product-to-cart-success';
            el.textContent = SUCCESS_TEXT;
            this.$button.appendChild(el);
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            return [{
                id: +this.getAttribute(ATTR_VARIANT_ID),
                quantity: 1
            }]
        }

        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        set added(state) {
            this.$button.classList.toggle(CN_ADDED, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();
